import VueSocialSharing from "vue-social-sharing/src/vue-social-sharing";
export default defineNuxtPlugin((NuxtApp) => {
  NuxtApp.vueApp.use(VueSocialSharing);
});
